import clsx from 'clsx';

import Header from '@/components/Header';
import { useSelector } from '@/redux/helper';

import HeaderPhoto from '../../layouts/LoginSignup/HeaderPhoto';
import style from './style.scss';

const Gift = () => {
  const giftCardConfig = useSelector((state) => state.remoteConfig.giftCardConfig);
  return (
    <div className={style.giftPage}>
      <Header />
      <div className={style.contentContainer}>
        <div className={style.contentWrapper}>
          <HeaderPhoto
            mobileImageUrl={giftCardConfig?.enabled ? giftCardConfig?.giftPageImage?.mobile : undefined}
            desktopImageUrl={giftCardConfig?.enabled ? giftCardConfig?.giftPageImage?.desktop : undefined}
          />
          <div className={clsx(style.formSection, 'customScrollBar grey')}>
            <div className={style.formWrapper}>
              <div className="gift-up-target" data-site-id="532caea9-ee00-447d-afab-114c9c57c7a9" data-platform="Other" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gift;
